import { render, staticRenderFns } from "./TakePhoto.vue?vue&type=template&id=c44c780c&scoped=true&"
import script from "./TakePhoto.vue?vue&type=script&lang=js&"
export * from "./TakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./TakePhoto.vue?vue&type=style&index=0&id=c44c780c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44c780c",
  null
  
)

export default component.exports